import { Theme } from '@mui/material/styles';
import { buttonClasses } from '@mui/material/Button';
import MuiScheduleIcon from '@mui/icons-material/Schedule';
import MuiArrowBackIcon from '@mui/icons-material/ArrowBack';
import MuiExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MuiArrowForwardIcon from '@mui/icons-material/ArrowForward';
import MuiCalendarMonthIcon from '@mui/icons-material/CalendarMonth';

import MuiIcon from 'src/components/mui-icon';

// ----------------------------------------------------------------------

const dateList = [
  'DatePicker',
  'DateTimePicker',
  'StaticDatePicker',
  'DesktopDatePicker',
  'DesktopDateTimePicker',
  //
  'MobileDatePicker',
  'MobileDateTimePicker',
];

const timeList = ['TimePicker', 'MobileTimePicker', 'StaticTimePicker', 'DesktopTimePicker'];

const switchIcon = () => <MuiIcon icon={MuiExpandMoreIcon} width={24} />;

const leftIcon = () => <MuiIcon icon={MuiArrowBackIcon} width={24} />;

const rightIcon = () => <MuiIcon icon={MuiArrowForwardIcon} width={24} />;

const calendarIcon = () => <MuiIcon icon={MuiCalendarMonthIcon} width={24} />;

const clockIcon = () => <MuiIcon icon={MuiScheduleIcon} width={24} />;

const desktopTypes = dateList.reduce((result: Record<string, any>, currentValue) => {
  result[`Mui${currentValue}`] = {
    defaultProps: {
      slots: {
        openPickerIcon: calendarIcon,
        leftArrowIcon: leftIcon,
        rightArrowIcon: rightIcon,
        switchViewIcon: switchIcon,
      },
    },
  };

  return result;
}, {});

const timeTypes = timeList.reduce((result: Record<string, any>, currentValue) => {
  result[`Mui${currentValue}`] = {
    defaultProps: {
      slots: {
        openPickerIcon: clockIcon,
        rightArrowIcon: rightIcon,
        switchViewIcon: switchIcon,
      },
    },
  };

  return result;
}, {});

export function datePicker(theme: Theme) {
  return {
    MuiPickersLayout: {
      styleOverrides: {
        root: {
          '& .MuiPickersLayout-actionBar': {
            [`& .${buttonClasses.root}:last-of-type`]: {
              backgroundColor: theme.palette.text.primary,
              color:
                theme.palette.mode === 'light'
                  ? theme.palette.common.white
                  : theme.palette.grey[800],
            },
          },
        },
      },
    },

    // Date
    ...desktopTypes,

    // Time
    ...timeTypes,
  };
}
